// @generated by protoc-gen-es v2.16.0 with parameter "target=js+dts"
// @generated from file invite/invite.proto (package invite, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file invite/invite.proto.
 */
export const file_invite_invite = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message invite.Person.
 * Use `create(PersonSchema)` to create a new message.
 */
export const PersonSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 0);

/**
 * Describes the message invite.Household.
 * Use `create(HouseholdSchema)` to create a new message.
 */
export const HouseholdSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 1);

/**
 * Describes the message invite.HouseholdMember.
 * Use `create(HouseholdMemberSchema)` to create a new message.
 */
export const HouseholdMemberSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 2);

/**
 * Describes the message invite.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 3);

/**
 * Describes the message invite.Invitee.
 * Use `create(InviteeSchema)` to create a new message.
 */
export const InviteeSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 4);

/**
 * Describes the message invite.InviteeWithStatus.
 * Use `create(InviteeWithStatusSchema)` to create a new message.
 */
export const InviteeWithStatusSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 5);

/**
 * Describes the message invite.RSVP.
 * Use `create(RSVPSchema)` to create a new message.
 */
export const RSVPSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 6);

/**
 * Describes the message invite.RSVPAttendee.
 * Use `create(RSVPAttendeeSchema)` to create a new message.
 */
export const RSVPAttendeeSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 7);

/**
 * Describes the message invite.HouseholdGroup.
 * Use `create(HouseholdGroupSchema)` to create a new message.
 */
export const HouseholdGroupSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 8);

/**
 * Describes the message invite.CreateEventRequest.
 * Use `create(CreateEventRequestSchema)` to create a new message.
 */
export const CreateEventRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 9);

/**
 * Describes the message invite.GetEventRequest.
 * Use `create(GetEventRequestSchema)` to create a new message.
 */
export const GetEventRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 10);

/**
 * Describes the message invite.AddInviteeRequest.
 * Use `create(AddInviteeRequestSchema)` to create a new message.
 */
export const AddInviteeRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 11);

/**
 * Describes the message invite.AddHouseholdInviteesRequest.
 * Use `create(AddHouseholdInviteesRequestSchema)` to create a new message.
 */
export const AddHouseholdInviteesRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 12);

/**
 * Describes the message invite.AddHouseholdInviteesResponse.
 * Use `create(AddHouseholdInviteesResponseSchema)` to create a new message.
 */
export const AddHouseholdInviteesResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 13);

/**
 * Describes the message invite.RemoveInviteeRequest.
 * Use `create(RemoveInviteeRequestSchema)` to create a new message.
 */
export const RemoveInviteeRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 14);

/**
 * Describes the message invite.RemoveInviteeResponse.
 * Use `create(RemoveInviteeResponseSchema)` to create a new message.
 */
export const RemoveInviteeResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 15);

/**
 * Describes the message invite.ListInviteesRequest.
 * Use `create(ListInviteesRequestSchema)` to create a new message.
 */
export const ListInviteesRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 16);

/**
 * Describes the message invite.ListInviteesResponse.
 * Use `create(ListInviteesResponseSchema)` to create a new message.
 */
export const ListInviteesResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 17);

/**
 * Describes the message invite.SubmitRSVPRequest.
 * Use `create(SubmitRSVPRequestSchema)` to create a new message.
 */
export const SubmitRSVPRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 18);

/**
 * Describes the message invite.SubmitRSVPResponse.
 * Use `create(SubmitRSVPResponseSchema)` to create a new message.
 */
export const SubmitRSVPResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 19);

/**
 * Describes the message invite.ListHouseholdsRequest.
 * Use `create(ListHouseholdsRequestSchema)` to create a new message.
 */
export const ListHouseholdsRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 20);

/**
 * Describes the message invite.ListHouseholdsResponse.
 * Use `create(ListHouseholdsResponseSchema)` to create a new message.
 */
export const ListHouseholdsResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 21);

/**
 * Describes the message invite.GetPersonRequest.
 * Use `create(GetPersonRequestSchema)` to create a new message.
 */
export const GetPersonRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 22);

/**
 * Describes the message invite.ListPersonsRequest.
 * Use `create(ListPersonsRequestSchema)` to create a new message.
 */
export const ListPersonsRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 23);

/**
 * Describes the message invite.ListPersonsResponse.
 * Use `create(ListPersonsResponseSchema)` to create a new message.
 */
export const ListPersonsResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 24);

/**
 * Describes the message invite.CreatePersonRequest.
 * Use `create(CreatePersonRequestSchema)` to create a new message.
 */
export const CreatePersonRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 25);

/**
 * Describes the message invite.CreateHouseholdRequest.
 * Use `create(CreateHouseholdRequestSchema)` to create a new message.
 */
export const CreateHouseholdRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 26);

/**
 * Describes the message invite.AddHouseholdMemberRequest.
 * Use `create(AddHouseholdMemberRequestSchema)` to create a new message.
 */
export const AddHouseholdMemberRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 27);

/**
 * Describes the message invite.RemoveHouseholdMemberRequest.
 * Use `create(RemoveHouseholdMemberRequestSchema)` to create a new message.
 */
export const RemoveHouseholdMemberRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 28);

/**
 * Describes the message invite.RemoveHouseholdMemberResponse.
 * Use `create(RemoveHouseholdMemberResponseSchema)` to create a new message.
 */
export const RemoveHouseholdMemberResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 29);

/**
 * Describes the message invite.ListEventsRequest.
 * Use `create(ListEventsRequestSchema)` to create a new message.
 */
export const ListEventsRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 30);

/**
 * Describes the message invite.ListEventsResponse.
 * Use `create(ListEventsResponseSchema)` to create a new message.
 */
export const ListEventsResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 31);

/**
 * Describes the message invite.ClaimHouseholdRequest.
 * Use `create(ClaimHouseholdRequestSchema)` to create a new message.
 */
export const ClaimHouseholdRequestSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 32);

/**
 * Describes the message invite.ClaimHouseholdResponse.
 * Use `create(ClaimHouseholdResponseSchema)` to create a new message.
 */
export const ClaimHouseholdResponseSchema = /*@__PURE__*/
  messageDesc(file_invite_invite, 33);

/**
 * Describes the enum invite.PersonType.
 */
export const PersonTypeSchema = /*@__PURE__*/
  enumDesc(file_invite_invite, 0);

/**
 * @generated from enum invite.PersonType
 */
export const PersonType = /*@__PURE__*/
  tsEnum(PersonTypeSchema);

/**
 * Describes the enum invite.MemberRole.
 */
export const MemberRoleSchema = /*@__PURE__*/
  enumDesc(file_invite_invite, 1);

/**
 * @generated from enum invite.MemberRole
 */
export const MemberRole = /*@__PURE__*/
  tsEnum(MemberRoleSchema);

/**
 * Describes the enum invite.RSVPStatus.
 */
export const RSVPStatusSchema = /*@__PURE__*/
  enumDesc(file_invite_invite, 2);

/**
 * @generated from enum invite.RSVPStatus
 */
export const RSVPStatus = /*@__PURE__*/
  tsEnum(RSVPStatusSchema);

/**
 * InviteService manages event invitations, RSVPs, and household memberships.
 *
 * @generated from service invite.InviteService
 */
export const InviteService = /*@__PURE__*/
  serviceDesc(file_invite_invite, 0);

